import React, { useEffect } from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import LearnMore from "../../../../components/learnMore/learnMore";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/numberOfActiveMembersBySagas";
import PropTypes from "prop-types";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import LineOrTableChart from "./smartComponents/LineOrTableChart";
import PeriodType from "./smartComponents/PeriodType";
import TableChart from "./smartComponents/TableChart";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import { ScoreCards } from "./smartComponents/scoreCards";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import PosTable from "./smartComponents/PosTable";
import "./numberOfActiveMembersByModule.css.scss";
import MembershipMetricFilter from "./smartComponents/MembershipMetricFilter";
import MembershipTypeFilter from "./smartComponents/MembershipTypeFilter";
import GroupBy from "./smartComponents/GroupBy";

const NumberOfActiveMembersByModule = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.numberOfActiveMembersBy.isLoading);
  const initialRequest = useSelector((state) => state.numberOfActiveMembersBy.initialRequest);
  const isFiltersLoading = useSelector((state) => state.numberOfActiveMembersBy.isFiltersLoading);

  const updatesLoading = useSelector((state) => state.numberOfActiveMembersBy.updatesLoading);
  const showNoDataMessage = useSelector((state) => state.numberOfActiveMembersBy.showNoDataMessage);

  const { showPosModal, iLearnContent, metric } = useSelector(
    (state) => state.numberOfActiveMembersBy.metric_params
  );

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className="top-filter__left">
              {metric === "MembersByMembershipType" ? (
                <>
                  <div className="select-box-no-width" style={{ maxWidth: "130px" }}>
                    <p>Membership Type</p>
                    {isFiltersLoading ? (
                      <button className="picky__input">
                        <LoadingAnimation uiLoader />{" "}
                      </button>
                    ) : (
                      <>
                        <MembershipTypeFilter />
                      </>
                    )}
                  </div>
                  <div className="select-box-no-width" style={{ width: "190px" }}>
                    <p>Group</p>
                    <GroupBy />
                  </div>
                </>
              ) : null}
            </div>
            <div className="top-filter__right">
              <div className="select-box-no-width">
                <p>Period Type</p>
                <PeriodType />
              </div>

              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>
              <div className="date-select-box select-box-no-width multi">
                <p>Date</p>
                <DatePicker />
              </div>
              <UpdateButtons />
            </div>
          </div>
        </div>

        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : showNoDataMessage ? (
            <p className="error">No data found for selected date.</p>
          ) : (
            <>
              <ScoreCards />
              <LineOrTableChart />
              <div className="add-color">
                <TableChart />
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="numberOfActiveMembersByModule-root">
      <SectionToggle
        autoHeight
        height={690}
        title="Members by"
        learnMore={
          <>
            <MembershipMetricFilter />
            {iLearnContent && (
              <LearnMore html title={iLearnContent.title} content={iLearnContent.body} />
            )}
            {showPosModal && (
              <LearnMore
                title="Packages tracked as membership"
                content={<PosTable />}
                additionalInfo
                customStyles={{
                  maxHeight: "initial"
                }}
                testId="additionalInfoButton"
              />
            )}
          </>
        }
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};

NumberOfActiveMembersByModule.propTypes = {
  params: PropTypes.object,
  learnMore: PropTypes.object
};

export default React.memo(NumberOfActiveMembersByModule);
